import { Box, Container, VStack, Text } from '@bpba/ui-components';
import { Banner } from '../components/Banner';

import { PRESTAMO_A_DISTANCIA } from '../Constantes';
import AdhesionPrestamosADistanciaComponente from '../components/AdhesionPrestamosADistanciaComponente';



export const AdhesionPortalPrestamosADistancia: React.FC = () => {



    return (

        <Container>
            <VStack>
                <VStack>
                    <Banner borderRadius={['0px', '8px']} url={PRESTAMO_A_DISTANCIA} />
                    <Box flexDirection={['column', 'row']}>
                        <Box>
                            <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>
                                <Text children={'Adhesión de Proveedores'} color={'primary.0'} fontSize={'30px'} lineHeight={"34px"} my={0} mx={0} tabIndex={0}></Text>
                                <br></br>
                                <text>Completá tus datos y, a la brevedad, nos pondremos en contacto con vos para responder tus consultas y coordinar un turno. Una vez asignado, te esperamos en la sucursal el día acordado para finalizar la contratación</text>

                            </VStack>
                        </Box>
                        <Box
                            width={["100%", "90%", "85%", "65%"]}
                            p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]}
                            mr={["0px", "15px", "20px", "50px"]}
                            bg="secondary.2"
                            minHeight={["400px", "500px", "500px"]}>
                            <AdhesionPrestamosADistanciaComponente />
                        </Box>
                    </Box>
                    <Box py={4} px={['16px', null, null, '50px']}>

                        <Text fontSize={"12px"} lineHeight={"18px"} textAlign={"justify"}>

                            El clic en SÍ ACEPTO implica conformidad para que los datos de esta presolicitud sean enviados al Banco de la Provincia de Buenos Aires y sin que ello importe su aceptación. Asimismo, tomo conocimiento de los <a style={{ color: "rgb(60, 60, 59)" }} href='https://www.bancoprovincia.com.ar/CDN/Get/TYC_BIP'>términos y condiciones para la utilización de Banca Internet Provincia</a> y de la información necesaria para su correcta utilización, los riesgos derivados de su empleo y quien asume los mismos. El clic en IMPRIMIR me permite obtener una copia que también se encuentra a la disposición en www.bancoprovincia.com.ar
                        </Text>
                    </Box>
                </VStack>

            </VStack>
        </Container>

    )
};
